module.exports = __webpack_public_path__ + "63934a41d8b4e00ab1c39b7b785cb525.svg";